import DomainModel from './DomainModel'

export default class VisitPurposeModel extends DomainModel {
    constructor(private id: string, private purpose: string,) {
        super()
    }
    getId = () => this.id
    getPurpose = () => this.purpose
}
